"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
exports.default = function (array) {
  if (Array.isArray(array) && array.length === 3) {
    return new (Function.prototype.bind.apply(Date, [null].concat(_toConsumableArray(array.map(function (v) {
      return ~~v;
    }).reverse().map(function (v, index) {
      return index === 1 ? v - 1 : v;
    })))))();
  }
  return new Date();
};